import fetch from '@/utils/fetch'

export function login(username, password) {
  return fetch({
    url: '/user/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

import EnvBase from '@/env'
import { agencyQnbarRequest_noalert } from '@/utils'

export function getInfo() {
  const token = EnvBase.PT.qnlogin.getLocalSess()
  return agencyQnbarRequest_noalert('getdetail', { local_sess: token })
}

export function logout() {
  return fetch({
    url: '/user/logout',
    method: 'post'
  })
}

export function getRolePermissions() {
  return agencyQnbarRequest_noalert('getAllPermissions')
}



// WEBPACK FOOTER //
// ./src/api/login.js